import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import {
  CreateMaintenanceInvoice,
  CreateMaintenanceInvoiceVariables,
} from '../../../athena/types/CreateMaintenanceInvoice';

export const MUTATION = gql`
  mutation CreateMaintenanceInvoice(
    $orgId: String!
    $startPeriodOn: OdProtosCommon_DateInput!
    $endPeriodOn: OdProtosCommon_DateInput!
  ) {
    webMaintenance {
      createMaintenanceInvoice(
        input: { organizationId: $orgId, startPeriodOn: $startPeriodOn, endPeriodOn: $endPeriodOn }
      ) {
        invoiceId
      }
    }
  }
`;

export const useCreateMaintenanceInvoice = () => {
  return useMutation<CreateMaintenanceInvoice, CreateMaintenanceInvoiceVariables>(MUTATION);
};
